module.exports = __webpack_public_path__ + "static/media/SG.079f8b71.webp";